// extracted by mini-css-extract-plugin
export var centeredContent = "v_bs";
export var heroWithTitle = "v_bq";
export var pageContent = "v_x";
export var starIcon = "v_br";
export var subtitleContainer = "v_F";
export var titleContainer = "v_bn";